import { IconWarning } from '@americanexpress/dls-icons';
import React from 'react';
import PropTypes from 'prop-types';

const ErrorMessage = ({ errors }) => (
  <p className="margin-1-t color-status-graphic-critical label">
    <IconWarning color="critical" size="md" isFilled={true} className="margin-1-r" />
    {errors.reduce((previousError, currentError) => `${previousError} ${currentError}`, '')}
  </p>
);

ErrorMessage.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.string),
};

export default ErrorMessage;
